import React from "react";

// This context will initially hold an empty object or array
const TablesRefContext = React.createContext<Record<string, React.MutableRefObject<undefined>>>({});

export const useTablesRef = (): Record<string, React.MutableRefObject<undefined>> => {
  const context = React.useContext(TablesRefContext);
  if (typeof context === "undefined") {
    throw new Error("useTablesRef must be used within a TablesRefProvider");
  }
  return context;
};

export const TablesRefProvider: React.FC = (props) => {
  const manualContactTableRef = React.useRef();
  const waitlistUpdateTableRef = React.useRef();

  const tableRefs = React.useMemo(() => ({
    manualContactTableRef,
    waitlistUpdateTableRef,
  }), []);

  return (
    <TablesRefContext.Provider value={tableRefs}>
      {props.children}
    </TablesRefContext.Provider>
  );
};
